import { FC, useEffect, useState } from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router";
import DynamicFavicon from "@/components/DynamicFavicon/DynamicFavicon";

import { URL } from "@/constants";
import { PageLayout } from "@/layout/Page";
import { PageNotFound } from "@/pages";
import { hcpRoutes } from "@/routes/routes";
import { getClientID } from "@/utils";


const MainRoutes: FC = () => {
  const [loading, setLoading] = useState(true);
  const [routes, setRoutes] = useState([]);

  const client = getClientID();

  useEffect(() => {
    setRoutes(hcpRoutes);
    setLoading(false);
  }, [client]);

  if (loading) return null;

  return (
    <>
      <DynamicFavicon />
      <RouterRoutes location={location}>
        {routes.map(({ path, Component, pageTitle }) => {
          return (
            <Route
              key={path}
              path={path}
              element={
                <PageLayout>
                  <Component pageTitle={pageTitle} />
                </PageLayout>
              }
            />
          );
        })}
        <Route path={URL.PAGE_NOT_FOUND} element={<PageNotFound />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </RouterRoutes>
    </>
  );
};

export default MainRoutes;
